import { loginPath, pathnameWithoutLocale } from "@outschool/routes";
import { useSession } from "@outschool/ui-auth";
import { Loading } from "@outschool/ui-legacy-component-library";
// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import React from "react";
import { Redirect, Route, Switch, useLocation } from "react-router";

import ParentDashboardV2 from "../components/parentDashboardV2";
import useDashboardLinks from "../components/parentDashboardV2/hooks/useDashboardLinks";
import LoggedOutUserHome from "./LoggedOutUserHome";
import NotFoundPage from "./NotFoundPage";

export default function Home() {
  const { isLoggedIn, currentUserHasLoaded } = useSession();
  const dashboardLinks = useDashboardLinks();
  const location = useLocation();

  if (!currentUserHasLoaded) {
    return <Loading />;
  }

  if (!isLoggedIn) {
    const currentPath = pathnameWithoutLocale(location.pathname);
    const dashboardPaths = dashboardLinks
      .filter(link => link.to !== "/")
      .map(link => link.to);

    if (dashboardPaths.includes(currentPath)) {
      return <Redirect to={loginPath()} />;
    }
  }

  const path = dashboardLinks.map(link => link.to) as string[];

  return (
    <>
      <div data-test-id="logged_in_home" />
      <Switch>
        <Route
          path={path}
          component={isLoggedIn ? ParentDashboardV2 : LoggedOutUserHome}
        />
        {/* Non-existing routes will be caught here */}
        <Route component={NotFoundPage} />
      </Switch>
    </>
  );
}
